module.exports = __webpack_public_path__ + "img/25.010b56e1.jpg";